import { render, staticRenderFns } from "./anmeldung.vue?vue&type=template&id=86a5c7a8&"
import script from "./anmeldung.vue?vue&type=script&lang=js&"
export * from "./anmeldung.vue?vue&type=script&lang=js&"
import style0 from "./anmeldung.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports